<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">{{ title }}</div>
    <!-- 地址列表 -->
    <div class="mainBox">
      <div class="mainBox_article">
        <p style="text-align: center">
          <strong
            ><span style="font-size: 29px; font-family: 宋体"
              >收货确认</span
            ></strong
          ><strong
            ><span style="font-size: 29px; font-family: 宋体"
              >授权书</span
            ></strong
          >
        </p>
        <p style="text-align: center">
          <strong><span style="font-size: 29px">&nbsp;</span></strong>
        </p>
        <p>
          <span style="font-size: 19px; font-family: 宋体"
            >江苏省苏合农副产品展销展示中心有限公司：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 38px">
          <span style="font-size: 19px; font-family: 宋体">我单位是</span
          ><span
            style="font-size: 19px; text-decoration: underline; margin: 0 15px"
            >{{
              $cookies.get("userInfo") ? $cookies.get("userInfo").name : ""
            }}</span
          ><span style="font-size: 19px; font-family: 宋体"
            >帐号的合法拥有者，兹授权</span
          ><span style="font-size: 19px; font-family: 宋体">该</span
          ><span style="font-size: 19px; font-family: 宋体">帐号在</span
          ><span style="font-size: 19px; font-family: 宋体">贵公司</span
          ><span style="font-size: 19px; font-family: 宋体">“鲜丰汇”</span
          ><span style="font-size: 19px; font-family: 宋体">电商</span
          ><span style="font-size: 19px; font-family: 宋体">平台上代表</span
          ><span style="font-size: 19px; font-family: 宋体">我单位</span
          ><span style="font-size: 19px; font-family: 宋体"
            >进行订单提交、确认收货、订单结算等采购行为。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 37px">
          <span style="font-size: 19px">1、</span
          ><span style="font-size: 19px; font-family: 宋体"
            >该账号在“鲜丰汇”平台上提交的订单信息为我单位确认采购需求。</span
          >
        </p>
        <p style="margin-left: 0; text-indent: 37px">
          <span style="font-size: 19px">2、</span
          ><span style="font-size: 19px; font-family: 宋体"
            >该账号在“鲜丰汇”平台上进行“确认收货”操作即代表我单位已经确认收到订单采购商品并确认无误。</span
          >
        </p>
        <p style="text-indent: 37px">
          <span style="font-size: 19px">3</span
          ><span style="font-size: 19px; font-family: 宋体"
            >、我单位将依据“鲜丰汇”平台相关约定及时结算付款。</span
          >
        </p>
        <p style="text-indent: 37px">
          <span style="font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px">
          <span style="font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px">
          <span style="font-size: 19px; font-family: 宋体">特此授权。</span>
        </p>
        <p>
          <span style="font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-align: center">
          <span style="font-size: 19px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 宋体">授权</span
          ><span style="font-size: 19px; font-family: 宋体">单位</span
          ><span style="font-size: 19px; font-family: 宋体">（盖章）：</span
          ><span style="font-size: 19px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
        </p>
        <p style="text-align: right">
          <span style="font-size: 19px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </p>
        <p style="text-align: center">
          <span style="font-size: 19px"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 19px; font-family: 宋体">日期：</span
          ><span style="font-size: 19px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span>
        </p>
        <p>&nbsp;</p>
        <p>
          <br />
        </p>
      </div>
      <div class="mainBox_btnBox">
        <el-upload
          v-if="uploadStatus != 2"
          class="upload-demo"
          :action="baseURL + uploadUrl"
          :data="{

          }"
          :on-success="uploadSuccess"
          :limit="1"
          :file-list="fileList"
          :show-file-list="false"
        >
          <el-button
            icon="el-icon-upload"
            style="
              width: 161px;
              height: 53px;
              border-color: #f89a00;

              margin-right: 16px;
            "
            >{{ uploadStatus == 0 ? "上传附件" : "重新上传" }}</el-button
          >
        </el-upload>
        <el-button
          v-else
          icon="el-icon-success"
          style="
            width: 161px;
            height: 53px;
            border: none;
            color: #07811f;
            cursor: auto;
            background-color: #fff;
            margin-right: 16px;
          "
          >已同意签署</el-button
        >
        <a
          :href="downloadUrl"
          download="采购人授权书.docx"
          style="text-decoration: underline"
        >
          <el-button
            type="primary"
            icon="el-icon-download"
            style="width: 161px; height: 53px"
            >立即下载</el-button
          ></a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { doGet, baseURL } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      baseURL,
      uploadStatus: 0,
      downloadUrl: "/static/platformAuthorization.docx",
      uploadUrl: httpConfig.myAgreement.uploadAgreementUrl, //上传文件接口
      fileList: [], //上传文件列表
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    /**
     * 获取是否已上传附件
     */
    getStatus() {
      var that = this;
      doGet(
        httpConfig.myAgreement.getAgreementInfoUrl,
        {  },
        function (res) {
          if (res.flag) {
            //uploadStatus=0,未上传
            //uploadStatus=1,重新上传
            //uploadStatus=2,已同意
            if (!res.data) {
              that.uploadStatus = 0;
            } else {
              if (res.data.status == 0 && !res.data.agreementUrl) {
                that.uploadStatus = 0;
              } else if (res.data.status == 0 && res.data.agreementUrl) {
                that.uploadStatus = 1;
              } else if (res.data.status == 1) {
                that.uploadStatus = 2;
              } else if (res.data.status == 2) {
                that.uploadStatus = 1;
              }
            }
          }
        }
      );
    },

    /**
     * 上传附件成功后的回调
     */
    uploadSuccess(response, file, fileList) {
      if (response.flag) {
        this.$message.success("上传成功");
        this.getStatus();
      }
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/platformAuthorization";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/platformAuthorization.vue